import { API_URL } from './constants';
import { getValidKeycloakAccessTokenOrFallback } from '../keycloak';

const getAuthHeaders = async (token = null, includeContentType = true) => {
  const headers = includeContentType ? { 'Content-Type': 'application/json' } : {};
  const activeToken = await getValidKeycloakAccessTokenOrFallback(token);

  if (activeToken) {
    headers.Authorization = `Bearer ${activeToken}`;
  }

  return headers;
};

/**
 * API Service component that is used to communicate with the imsWebAPI.
 */
const apiService = {
  postRequest: async (endpoint, data, token = null) => {
    try {
      const response = await fetch(`${API_URL}/${endpoint}`, {
        method: 'POST',
        headers: await getAuthHeaders(token),
        body: JSON.stringify(data),
      });

      //If (!response.ok) {
      //  Throw new Error(`An HTTP error occurred! Status: "${response.status}"`);
      //}

      return response.json();
    } catch (error) {
      console.error('An API error occurred! Status: ', JSON.stringify(error, null, 2));
      throw error;
    }
  },
  postFormData: async (endpoint, formData, token = null) => {
    try {
      const headers = await getAuthHeaders(token, false);

      const response = await fetch(`${API_URL}/${endpoint}`, {
        method: 'POST',
        headers: headers,
        body: formData,
      });

      // if (!response.ok) {
      //   throw new Error(`An HTTP error occurred! Status: "${response.status}"`);
      // }

      return response.json();
    } catch (error) {
      console.error('An API error occurred in postFormData!', error);
      throw error;
    }
  },
  getRequest: async (endpoint, token = null) => {
    try {
      const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'GET',
        headers: await getAuthHeaders(token),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const text = await response.text();
      return JSON.parse(text);
    } catch (error) {
      console.error('An API error occurred! Status: ', JSON.stringify(error, null, 2));
      throw error;
    }
  },
  imageRequest: async (endpoint, data, token = null) => {
    try {
      const response = await fetch(`${API_URL}/${endpoint}`, {
        method: 'POST',
        headers: await getAuthHeaders(token),
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`An HTTP error occurred! Status: "${response.status}"`);
      }
      const blob = await response.blob();
      const objectURL = URL.createObjectURL(blob);
      return objectURL;
    } catch (error) {
      console.error('An API error occurred! Status: ', JSON.stringify(error, null, 2));
      throw error;
    }
  },
};

export default apiService;
